<template>
  <div class="planos">
    <header-primary
      title="Planos"
      subtitle="Consulte os planos para você e seu negócio."
      :image="require('../assets/background/bg_line_planos.jpg')"></header-primary>
    <md-empty-state
      md-rounded
      v-if="false"
      class="mt-5 mb-5"
      md-icon="build"
      md-label="Planos Indisponíveis no Momento">
    </md-empty-state>
    <router-view v-else></router-view>
    <div class="container">
      <button-large-light
        :link="`/${this.$route.params.cidade}/contato`"
        titulo="Você é um Provedor?"
        sub-titulo="Clique aqui e saiba como se tornar nosso parceiro."
        class="mt-5 mb-5">
      </button-large-light>
    </div>
  </div>
</template>

<script>
import HeaderPrimary from "../components/HeaderPrimary";
import ButtonLargeLight from "../components/ButtonLargeLight";

export default {
  name: "Planos",
  components: { HeaderPrimary, ButtonLargeLight }
};
</script>

<style scoped>
</style>
